import './App.css';
import { HeaderComponent } from './headerComponent/HeaderComponent';
import { Section1Component } from './Section1Component/Section1Component';
import {Section2AnchorComponent} from './Section2AnchorComponent/Section2AnchorComponent'
import { Section2Component } from './Section2Component/Section2Component';
import { Section3Component } from './Section3Component/Section3Component';
import { Section4Component } from './Section4Component/Section4Component';
import { Section5Component } from './Section5Component/Section5Component';
import { Section6Component } from './Section6Component/Section6Component';
import { FooterComponent } from './footerComponent/FooterComponent';

function App() {

  return (
    <>
        <HeaderComponent></HeaderComponent>
        <Section1Component ></Section1Component>
        <Section2AnchorComponent></Section2AnchorComponent>
        <Section2Component></Section2Component> 
        <Section3Component></Section3Component>
        <Section4Component></Section4Component>
        <Section5Component></Section5Component>
        <Section6Component></Section6Component>
        <FooterComponent></FooterComponent>
    </>
  );
}

export default App;
